<template>
  <div>
    <nav
      v-if="!isMobile()"
    >
      <div id="basic-navbar">
        <div class="basic-navbar-left" >
          <img
            @click="goToHome"
            class="logo-img"
            src="@/assets/images/logo_x1jets.png"
            alt="airspirit"
          />
          <div
            @click="goToHome"
            class="basic-navbar-left--title basic-navbar-left--title--desktop"
          >
            AIRspirit
          </div>
        </div>
        <div class="basic-navbar-center">
          <div 
            class="nav-menu-desktop"
            style="display: flex;"
          >
            <div
              class="nav-menu-desktop-item" style="border-right: 1px solid rgb(163, 163, 163);"
            >
              <a
                href="/fly"
                @click.prevent="goToPage('fly')"
                :class="{ 'nav-menu-desktop-item-link--not-active': section !== 'fly' }"
              >
                {{ $t("navbar.fly") }}

              </a>
            </div>
            <div
              class="nav-menu-desktop-item"
              style="border-right: 1px solid rgb(163, 163, 163);"
            >
              <a
                href="/learn"
                @click.prevent="goToPage('learn')"
                :class="{ 'nav-menu-desktop-item-link--not-active': section !== 'learn' }"
              >
                {{ $t("navbar.learn") }}
              </a>
            </div>
            <div 
              class="nav-menu-desktop-item" 
              style="border-right: 1px solid rgb(163, 163, 163);"
            >
              <a
                href="/map"
                @click.prevent="goToPage('map')"
                :class="{ 'nav-menu-desktop-item-link--not-active': section !== 'map' }"
              >
                {{ $t("navbar.map") }}
              </a>
            </div>
            <div
              class="nav-menu-desktop-item"
            >
              <a
                href="/hub"
                @click.prevent="goToPage('hub')"
                :class="{ 'nav-menu-desktop-item-link--not-active': section !== 'hub' }"
              >
                {{ $t("navbar.hub") }}
              </a>
            </div>
            <div 
              class="nav-menu-desktop-input" 
              style="border-left: 1px solid rgb(163, 163, 163); position: relative;"
            >
              <input
                v-model="searchText"
                class="nav-menu-desktop-input-text"
                type="text"
                :placeholder="searchPlaceholder"
                @keyup.enter="search"
              />
              <div
                @click="search"
                class="nav-menu-desktop-input-button"
              >
                <img 
                  src="@/assets/images/pictos/picto_search.svg" 
                  alt="search" 
                />
              </div>
                <div v-if="isSearchDropdownOpen" class="search-dropdown-menu" ref="searchDropdownMenu">
                  <div 
                    @click="chooseSearch('fly')"
                    class="search-dropdown-item"
                  >
                    <img src="@/assets/images/home/icons/flight_management_black.svg" class="search-dropdown-item__icon" alt="fly" />
                    {{ $t("navbar.fly") }}
                  </div>
                  <div 
                    @click="chooseSearch('learn')"
                    class="search-dropdown-item"
                  >
                    <img src="@/assets/images/home/icons/learn_to_fly_black.svg" class="search-dropdown-item__icon" alt="learn" />
                    {{ $t("navbar.learn") }}
                  </div>
                  <div 
                    @click="chooseSearch('map')"  
                    class="search-dropdown-item"
                  >
                    <img src="@/assets/images/home/icons/map_pin_black.svg" class="search-dropdown-item__icon" alt="map" />
                    {{ $t("navbar.map") }}
                  </div>
                  <div 
                    @click="chooseSearch('hub')"
                    class="search-dropdown-item"
                  >
                    <img src="@/assets/images/home/icons/join_the_community_black.svg" class="search-dropdown-item__icon" alt="hub" />
                    {{ $t("navbar.hub") }}
                  </div>
                  <div class="search-dropdown-divider"></div>
                  <div 
                    @click="messageAirspirit"
                    class="search-dropdown-item"
                  >
                    <img src="@/assets/images/navbar/search_chat.png" class="search-dropdown-item__icon" alt="message" />
                    {{ $t("navbar.message") }}
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="basic-navbar-right">
          <div
            style="position: relative;"
          >
            <div 
              class="basic-navbar-right-language-div" 
              @click="toggleLanguage"
            >
              <img 
                class="basic-navbar-picto-img"
                src="@/assets/images/pictos/picto_world.png" 
                alt="languages" 
              />
            </div>
            <LanguageMenu
              v-if="showLanguagePopup"
              @close="showLanguagePopup = false"
            />
          </div>

          <div 
            class="basic-navbar-right-language-div" 
            @click="clickOnLogin"
          >
            <img 
              class="basic-navbar-picto-img"
              src="@/assets/images/pictos/picto_login.png" 
              alt="login" 
            />
          </div>
        </div>
      </div>
    </nav>
    <nav
      v-else
    >
      <div id="basic-navbar" class="basic-navbar--mobile">
        <div class="basic-navbar-left" style="display: flex; align-items: center;">
          <img 
            @click="goToHome"
            class="logo-img logo-img--mobile"
            src="@/assets/images/logo_x1jets.png" 
            alt="airspirit" 
          />
          <div
            class="basic-navbar-left--title basic-navbar-left--title--mobile"  
          >
            AIRspirit
          </div>
        </div>

        <div 
          class="basic-navbar-right" 
          @click="navbarMobileMenuOpen = !navbarMobileMenuOpen"
          style="cursor: pointer;"
        >
          <img 
            src="@/assets/images/navbar/menu.svg"
            alt="Menu"
            class="basic-navbar-menu-icon"
          />
        </div>
      </div>

      <NavbarMobileMenu
        v-if="navbarMobileMenuOpen"
        @close="navbarMobileMenuOpen = false"
        @open-language-modal="showLanguageMenuModal = true"
      />

      <LanguageMobileMenu
        v-if="showLanguageMenuModal"
        @close="showLanguageMenuModal = false"
      />

      <FooterMobile
        v-if="navbarMobileFooter"
        @close="navbarMobileFooter = false"
      />
      
    </nav>
  </div>
</template>

<script>
import FooterMobile from '@/components/footer/FooterMobile.vue'
import LanguageMenu from '@/components/language/LanguageMenu.vue'
import LanguageMobileMenu from '@/components/language/LanguageMobileMenu.vue'
import NavbarMobileMenu from '@/components/navbar/NavbarMobileMenu.vue'
import { mobileDetectionMixins } from '@/mixins/mobileDetection'

export default {
  name: 'BasicNavbar',
  props: {
    displayMenu: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    FooterMobile,
    LanguageMenu,
    LanguageMobileMenu,
    NavbarMobileMenu,
  },
  mixins: [mobileDetectionMixins],
  data: function () {
    return {
      currentLocale: "en",
      disabledChatInput: false,
      navbarMobileMenuOpen: false,
      navbarMobileFooter: false,
      showLanguageMenuModal: false,
      showLanguagePopup: false,
      isSearchDropdownOpen: false
    }
  },
  computed: {
    searchText: {
        get () { 
          return this.$store.state.searchText
        },
        set (value) { 
          this.$store.commit('set', ['searchText', value])
        }
    },
    searchPlaceholder () {
      if (this.section === 'fly') {
        return this.$t('navbar.search_fly')
      } else if (this.section === 'learn') {
        return this.$t('navbar.search_learn')
      } else if (this.section === 'map') {
        return this.$t('navbar.search_map')
      } else if (this.section === 'hub') {
        return this.$t('navbar.search_hub')
      } else {
        return this.$t('navbar.search_or_message')
      }
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    isLoginModal () {
      return this.$store.getters.isLoginModal
    },
    loginTextStyle () {
      if (this.isLoginModal) {
        return { color: 'black' }
      }
      else {
        return { color: '#B1B1B1' }
      }
    },
    section: function () {
      return this.$route.name
    },
  },
  watch: {
    '$route' (){
      this.navbarMobileFooter = false
      this.navbarMobileMenuOpen = false
    }
  },
  beforeUnmount () {
    this.$eventHub.$off('cleanNavbarInputText')
    this.$eventHub.$off('disableNavbarInputText')
    this.$eventHub.$off('enableNavbarInputText')
  },
  mounted () {
    // Set the initial locale from localStorage or default
    const savedLocale = localStorage.getItem("locale");
    if (savedLocale) {
      this.currentLocale = savedLocale;
      this.$i18n.locale = savedLocale;
    }

    this.$eventHub.$on('setSearch', (searchText) => {
      this.searchText = searchText
    })

    this.$eventHub.$on('disableNavbarInputText', () => {
      this.disabledChatInput = true
    })

    this.$eventHub.$on('enableNavbarInputText', () => {
      this.disabledChatInput = false
    })
  },

  methods: {
    chatHandleSubmit(e) {
      e.preventDefault();
    },
    clickOnLogin () {
      this.$store.commit('closeChat')
      if (this.isAuthenticated) {
        this.$router.push("/account")
      } else {
        this.$store.commit('openLoginModal')
      }
    },
    clickOnFilters () {
      this.$eventHub.$emit('openLanguageMenuModal')
    },
    chooseSearch (section) {
      if (section === 'hub') {
        this.$router.push('/hub')
      }
      else if (section === 'fly') {
        this.$router.push('/fly')
      }
      else if (section === 'map') {
        this.$router.push('/map')
      }
      else if (section === 'learn') {
        this.$router.push('/learn')
      }
      this.isSearchDropdownOpen = false
    },
    goToHome () {
      window.location.href = '/'
    },
    goToPage(page) {
      this.searchText = ''
      this.navbarMobileMenuOpen = false
      let route = this.$router.resolve({path: `/${page}`})
      window.location.href = route.href
    },
    handleClickOutside(event) {
      const dropdownMenu = this.$refs.searchDropdownMenu;
      if (dropdownMenu && !dropdownMenu.contains(event.target)) {
        this.isSearchDropdownOpen = false;
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    logoColor (pathName) {
      if (this.$route.name === pathName) {
        return 'black'
      }
      else {
        return 'grey'
      }
    },
    textColor (pathName) {
      if (this.$route.name === pathName) {
        return 'black'
      }
      else {
        return '#B1B1B1'
      }
    },
    search () {
      if (this.section === 'hub' || this.section === 'fly' || this.section === 'map' || this.section === 'learn') {
        this.$store.commit('set', ['search', this.searchText])
        this.$eventHub.$emit('search')
      }
      else {
        this.toggleDropdown()
      }
      
    },
    messageAirspirit() {
      const message = this.searchText.trim() || this.$t('navbar.default_contact_message');
      this.$store.commit('set', ['chatInitialMessage', message]);
      this.isSearchDropdownOpen = false;
      this.$router.push('/chat');
    },
    switchLocale(locale) {
      this.currentLocale = locale;
      this.dropdownOpen = false;

      // Assuming you are using vue-i18n
      this.$i18n.locale = locale;

      // Optional: Store the locale in localStorage to persist user preference
      localStorage.setItem("locale", locale);
    },
    toggleDropdown() {
      this.isSearchDropdownOpen = !this.isSearchDropdownOpen;
      if (this.isSearchDropdownOpen) {
        setTimeout(() => {
          document.addEventListener('click', this.handleClickOutside);
        }, 100);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    toggleLanguage() {
      if (this.isMobile()) {
        this.showLanguageMenuModal = !this.showLanguageMenuModal
      }
      else {
        this.showLanguagePopup = !this.showLanguagePopup
      }
    }
  }
}
</script>

<style>

a {
  color: black;
  text-decoration: none;
}
a:hover {
  color: black;
  text-decoration: none;
}

#basic-navbar {
  display: flex;
  height: 52px;
  background: white;
  padding-left: 4%;
  padding-right: 4%;
  border-bottom: 1px rgba(61, 61, 61, 0.1) solid; /* #3D3D3D (5%) */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

@media (min-width: 800px) {
  #basic-navbar {
    height: 120px;
    padding-right: 100px;
    padding-left: 100px;
    position: static;
  }
}

.basic-navbar-menu-icon {
  width: 22px;
  height: 22px;
  display: block;
}

.basic-navbar-left {
  flex: 1;          /* shorthand for: flex-grow: 1, flex-shrink: 1, flex-basis: 0 */
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.basic-navbar-left--title {
  font-size: 1.5em;
  font-weight: bold;
  margin-left: 10px;
}

.basic-navbar-left--title--mobile {
  font-size: clamp(1em, 4.5vw, 1.2em);
  margin-left: 8px;
  white-space: nowrap;
}

/* Displayed only on large enough desktop screens to keep the menu centered */
.basic-navbar-left--title--desktop {
  cursor: pointer;
  display: none;
  white-space: nowrap;
}

@media (min-width: 800px) {
  .basic-navbar-left--title {
    margin-left: 15px;
  }
}

@media (min-width: 1200px) {
  .basic-navbar-left--title--desktop {
    display: block;
  }
}


.basic-navbar-center {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-img {
  cursor: pointer;
  height: 40px;
}

.logo-img--mobile {
  height: 32px;
}

@media (min-width: 800px) {
  .logo-img {
    cursor: pointer;
    height: 45px;
  }
}

.basic-navbar-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 7px;
}

.basic-navbar-right-language-div {
  padding: 10px;
  border-radius: 50%;
}

.basic-navbar-right-language-div:hover {
  background-color: #DEDEDE;
}
.basic-navbar-right-language-div--disabled:hover {
  background-color: transparent !important;
}

.basic-navbar-picto-img {
  cursor: pointer;
  height: 25px;
  display: block;
  margin: auto;
}

.basic-navbar-picto-img--disabled {
  cursor: auto! important;
}


.nav-menu-desktop {
  border-radius: 50px;
  border: 1px solid rgb(163, 163, 163);
  display: flex;
  justify-content: space-around;
  padding-top: 5px;
  padding-bottom: 5px;
  margin: auto;
  width: 700px;
}
.nav-menu-desktop-item {
  align-items: center;
  color: rgba(255, 255, 255, .3);
  cursor: pointer;
  display: flex;
  font-weight: bold;
  gap: 15px;
  justify-content: center;
  width: 15%;
}

.nav-menu-desktop-item > a {
  color: black;
  text-decoration: none;
}

.nav-menu-desktop-item--disabled {
  cursor: auto !important;
}

.nav-menu-desktop-item-link--not-active {
  color: rgb(163, 163, 163) !important;
}

.nav-menu-desktop-input {
  display: flex;
  padding-right: 10px;
  padding-left: 10px;
  width: 40%;
}

.nav-menu-desktop-input-text {
  border: none;
  outline: none;
  width: 100%;
}
.nav-menu-desktop-input-text:focus {
  border: none;
  outline: none;
}
.nav-menu-desktop-input-text:active {
  border: none;
  outline: none;
}
.nav-menu-desktop-input-text:focus-visible {
  border: none;
  outline: none;
}

.nav-menu-desktop-input-button {
  border-radius: 50%;
  cursor: pointer;
  padding: 3px 7px 5px 7px;
}

.nav-menu-desktop-input-button > img {
  width: 20px;
  height: 20px;
}

.nav-menu-desktop-chat-input-button {
  border-radius: 50%;
  cursor: pointer;
  padding: 3px 7px 5px 7px;
}

.nav-menu-desktop-chat-input-button > img {
  width: 25px;
  height: 25px;
}


/* Language  */
.language-filter-icon {
  cursor: pointer;
  width: 30px;
  height: 30px;
}

.language-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  list-style: none;
  padding: 8px 0;
  margin: 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.language-dropdown li {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.language-dropdown li:hover {
  background: #f0f0f0;
}

.language-menu-modal {
  border-radius: 10px !important;
}
.language-menu-modal-header {
  display: block !important;
}

.language-menu-modal-header--close-icon {
  cursor: pointer;
  padding: 10px;
  border-radius: 50%;
}

.language-menu-modal-header--close-icon:hover {
  background-color: #DEDEDE;
}


.language-menu-modal-header--close-icon > img {
  height: 10px;
  display: block;
  margin: auto;
}

.language-menu-modal-header--title {
  font-size: 1.1rem;
  font-weight: bold;
  margin: 0 auto; 
  text-align: center;
  width: 300px;
}

.language-menu-modal-body {
  padding: 10px 30px 30px 30px !important;
}

.search-dropdown-menu {
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: absolute;
  top: 150%;
  right: 0;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 160px;
  z-index: 1000;
  padding: 8px;
}

.search-dropdown-item {
  color: rgb(163, 163, 163);
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 8px;
  border-radius: 6px;
}

.search-dropdown-item:hover {
  color: black;
  background-color: #f5f5f5;
}

.search-dropdown-item:hover .search-dropdown-item__icon {
  opacity: 1;
}

.search-dropdown-item__icon {
  width: 15px;
  height: 15px;
  object-fit: contain;
  opacity: 0.4;
  flex-shrink: 0;
}

.search-dropdown-divider {
  height: 1px;
  background-color: rgba(163, 163, 163, 0.3);
  margin: 5px 0;
}
</style>